import { isFilled } from '@cobliteam/prismic';
import type { BlogPostDocumentDataRelationsItem } from '@cobliteam/prismic/src/types/support-cobli.generated';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';
import { motion } from 'motion/react';

interface RelationsListProps {
  relations: BlogPostDocumentDataRelationsItem[];
  onRelationSelect: (relation: BlogPostDocumentDataRelationsItem) => void;
}

const RelationsList = ({ relations, onRelationSelect }: RelationsListProps) => {
  return (
    <motion.div className='flex flex-1 flex-col space-y-6 p-4' initial='initial' animate='animate'>
      <Typography variant='heading-xl'>Guia de uso</Typography>
      <ul className='flex flex-col gap-4'>
        {relations?.map((relation) => {
          if (!isFilled.contentRelationship(relation.post)) return null;
          const post = relation.post;
          const data = post.data;
          if (!data) return null;

          return (
            <li
              key={post?.uid}
              className='flex cursor-pointer list-inside list-disc items-center gap-3 rounded-md border-gray-5 border-b p-3 shadow-sm transition-colors hover:bg-gray-3 hover:text-primary-9'
              onClick={() => onRelationSelect(relation)}
            >
              <Icon name='chevron-right' size='sm' className='flex-shrink-0 text-primary-11' />
              <Typography variant='text-md'>{data.title}</Typography>
            </li>
          );
        })}
      </ul>
    </motion.div>
  );
};

export default RelationsList;
